<div class="role-picker-wrapper">
  <!-- Trigger button -->
  <button
    #triggerBtn
    type="button"
    class="role-trigger"
    [class.is-open]="isOpen()"
    [class.is-disabled]="disabled()"
    [attr.aria-haspopup]="'listbox'"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-disabled]="disabled() || null"
    (click)="toggle()"
  >
    <span class="role-trigger__label">{{ selectedLabel() | translate }}</span>
    <svg
      class="role-trigger__chevron"
      [class.rotated]="isOpen()"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  </button>

  <!-- Dropdown: position:fixed so it escapes any overflow:hidden ancestor -->
  @if (isOpen()) {
    <ul
      class="role-listbox"
      role="listbox"
      [style.top.px]="dropdownTop()"
      [style.left.px]="dropdownLeft()"
      [style.min-width.px]="dropdownWidth()"
    >
      @for (option of options(); track option.value) {
        <li
          class="role-option"
          role="option"
          [attr.aria-selected]="option.value === value()"
          [class.is-selected]="option.value === value()"
          (click)="select(option.value)"
        >
          <span class="role-option__label">{{ option.label | translate }}</span>
          @if (option.value === value()) {
            <svg
              class="role-option__check"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          }
        </li>
      }
    </ul>
  }
</div>
